export type CompanyDetailTab = 'sows' | 'pulse-subscriptions' | 'teams' | 'users';

const ALL_COMPANY_DETAIL_TABS: CompanyDetailTab[] = [
    'sows',
    'teams',
    'users',
    'pulse-subscriptions',
];

export function getDefaultCompanyDetailTab(): CompanyDetailTab {
    return 'sows';
}

export function parseCompanyDetailTabParam(value: string | null): CompanyDetailTab | null {
    if (!value || !ALL_COMPANY_DETAIL_TABS.includes(value as CompanyDetailTab)) {
        return null;
    }

    return value as CompanyDetailTab;
}

export function buildCompanyDetailSearchParams(
    tab: CompanyDetailTab,
    expandTeam?: string,
): URLSearchParams {
    const params = new URLSearchParams();
    params.set('tab', tab);
    if (tab === 'teams' && expandTeam) {
        params.set('expandTeam', expandTeam);
    }
    return params;
}
